import AbstractService from "../AbstractService";
import generateBoundary from "../utils";

class BaseExpeditionService extends AbstractService {

  static listEndpoint = '';
  static additionalInfoEndpoint = '';


  static _getUrl(partUrl) {
    return `${super._getUrl()}/expedition${partUrl}`;
  }

  static async getExpeditionsFlags() {

    const url = this._getUrl(`/get-expeditions-flags`);
    const resp = await this._getResource(url);

    return {
      data: resp.results
    };
  }

  static async getList(params) {
    const { pageSize, urlParam } = this._getPageSizeUrlParamList(params);
    const url = this._getUrl(`/${this.listEndpoint}${urlParam}`);
    const resp = await this._getResource(url);
    return {
      pageSize: pageSize,
      totalCount: resp.count,
      data: resp.results
    };
  }
  static async getAdditionalInfo(itemId) {
    const url = this._getUrl(`/${itemId}/${this.additionalInfoEndpoint}`);
    const resp = await this._getResource(url);
    return {
      data: resp.results
    };
  }


  static async addTariffPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/add-tariff-price`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }

  static async addTariffPaidPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/add-tariff-paid-price`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }


  static async saveTariffPaidPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/save-tariff-price-paids`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }



  static async addStoragesPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/add-storages-price`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }

  static async addStoragesPaidPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/add-storages-paid-price`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }

  static async saveStoragesPaidPrice(itemId, data) {

    const url = this._getUrl(`/${itemId}/save-storage-price-paids`);
    const resp = await this._setResource(url,
      {
        data,
        headers: {
          'Content-Type': `multipart/form-data; boundary=${generateBoundary()}`,
        },
      });

    return {
      data: resp.results
    };

  }


  static async recalcPrices(itemId) {

    const url = this._getUrl(`/${itemId}/recalc-prices`);
    const resp = await this._setResource(url,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      });

    return {
      data: resp.result
    };
  }


  static async saveIsPayConfirmed(data) {

    const url = this._getUrl(`/change-pay-confirmed`);
    const resp = await this._setResource(url,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'post',
        data: JSON.stringify(data),
      });

    return {
      data: resp.results
    };
  }

}


export default BaseExpeditionService;